import { render } from "./esigning_setup.html?vue&type=template&id=8be98748&scoped=true&external"
import script from "./esigning_setup.js?vue&type=script&lang=js&external"
export * from "./esigning_setup.js?vue&type=script&lang=js&external"

import "../../Verification/manage_verification.css?vue&type=style&index=0&id=8be98748&scoped=true&lang=css&external"
import "../../Risk/risk_review.css?vue&type=style&index=1&id=8be98748&scoped=true&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be98748"]])

export default __exports__